import styled from 'styled-components'
import { colors } from '../../styles/colors'

export const PrimaryButton = styled.div`
    padding: 2rem 3rem;
    margin: 1rem;
    background: ${props => props.disabled ? 'grey' : props.lighten ? colors.white : colors.dark_blue};
    border-radius: 1.25rem;

    font-family: 'SF UI Text', sans-serif;
    font-weight: 400;
    font-size: 2.25rem;
    line-height: 160%;
    color: ${props => props.lighten ? colors.dark_blue : colors.white};
    text-align: center;

    cursor: ${props => props.disabled ? 'auto' : 'pointer'};
    ${props => props.disabled ? 'pointer-events: none;' : null }

    transition: all .5s;

    :hover {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
`
